import React from 'react';

import { Link } from '@infoods/lifebase-ui';

import classes from './TermsLink.module.scss';

const TermsLinks = () => {
  return (
    <p className={classes.termsLabel}>
      SWYMO&nbsp;
      <Link color="info" href="/useragreement.html" target="_blank">
        Terms & Conditions
      </Link>
      &nbsp;and&nbsp;
      <Link color="info" href="/privacyoverview.html" target="_blank">
        Privacy policy
      </Link>
    </p>
  );
};

export { TermsLinks };
